import { useQuery } from '@tanstack/react-query'
import { ViewChangelog } from '@xeetr/types/models'
import { useContext, useState } from 'react'

import { ActiveTenantContext } from '../../context/common/Context'
import { queryKeys } from '../../lib/queryKeys'
import { ChangelogService } from '../../services/Changelog.service'
import { useErrorHandler } from '../common/useErrorHandler'
import { useTenantOptionalService } from '../common/useServiceFactory'

interface UseCustomerChangelogsReturn {
  changelogs: ViewChangelog[]
  changelogsLoading: boolean
  changelogsSuccess: boolean
  loadChangelogs: (bookingId: string) => void
}

export const useCustomerChangelogs = (): UseCustomerChangelogsReturn => {
  const { tenantId } = useContext(ActiveTenantContext)
  const [bookingId, setBookingId] = useState<string | null>(null)

  const getChangelogService = useTenantOptionalService(ChangelogService)

  const changelogsQuery = useQuery({
    queryKey: queryKeys.changelog(bookingId || ''),
    queryFn: async () => {
      if (!tenantId || !bookingId) return []
      const service = await getChangelogService()
      return service.getChangelog(bookingId)
    },
    enabled: !!tenantId && !!bookingId,
    staleTime: 10 * 60 * 1000,
    retry: 2,
  })

  useErrorHandler(changelogsQuery.isError)

  return {
    changelogs: changelogsQuery.data || [],
    changelogsLoading: changelogsQuery.isLoading,
    changelogsSuccess: changelogsQuery.isSuccess,
    loadChangelogs: setBookingId,
  }
}
